<app-preloader *ngIf="previewloader" [loaderText]=" 'Loading Preview'" class="w-100 position-fixed preloader-backdrop">
</app-preloader>
<div class="container mt-4">
  <div class="row">
    <div class="col-12 d-flex justify-content-end">
      <div class="dropdown">
        <button class="btn btn-primary border px-4" id="download" type="button" aria-expanded="false"
          aria-haspopup="true" data-display="static" data-reference="parent" data-toggle="dropdown">Download</button>

        <div class="dropdown-menu dropdown-menu-right p-0" aria-labelledby="download">
          <div class="p-2 dropdown-menu-scrollable">
            <ul class="list-group">
              <li class="list-group-item p-0 border-0"
                *ngIf="reportType !== 'SNS' && reportType !== 'Taxonomy-Project' && reportType !== 'IRM' && reportType !== 'IRMExpanded'">
                <button
                  type="button"
                  class="btn btn-clear dropdown-item d-flex justify-content-between"
                  id="documentBtn"
                  (click)="downloadCoverageReport('download', 'docx')">Document
                    <span class="material-icons-outlined" aria-hidden="true">
                      file_download
                    </span>
                </button>
              </li>
              <li class="list-group-item p-0 border-0" *ngIf="reportType !== 'course'">
                <button
                  type="button"
                  class="btn btn-clear dropdown-item d-flex justify-content-between"
                  id="worksheetBtn"
                  (click)="downloadCoverageReport('download','xls')">Worksheet
                    <span class="material-icons-outlined" aria-hidden="true">
                      file_download
                    </span>
                </button>
              </li>
              <li class="list-group-item p-0 border-0" *ngIf="reportType !== 'Taxonomy-Project'">
                <button
                  type="button"
                  class="btn btn-clear dropdown-item d-flex justify-content-between"
                  id="pdfBtn"
                  (click)="downloadCoverageReport('download','pdf')">PDF
                    <span class="material-icons-outlined" aria-hidden="true">
                      file_download
                    </span>
                </button>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </div>

    <section class="col-12 p-0 table-responsive mt-4">
      <div id="previewContainer"></div>
    </section>
  </div>
</div>

<app-report-naming-modal [selectedTaxonomyTitle]="sourceTaxonomytitle" [formatSelected]="formatSelected"
  [selectedNode]="selectedNode" (reportDownloadEvent)="downloadReport($event)"></app-report-naming-modal>
